import { BaseObject } from '../core/BaseObject';

export class DeviceItem extends BaseObject {
    deviceId: number;
    deviceStatusId: number;
    deviceStatusName: string;
    deviceTypeId: number;
    deviceTypeName: string;
    deviceModelId: number;
    deviceModelName: string;
    deviceSupplierId: number;
    deviceSupplierName: string;
    serialNumber: string;
    installTypeId: number;
    installTypeName: string;
    marketPlaceId: number;
    marketPlaceName: string;
    existInRequestDevices: boolean;
    manufactureDate: Date;
}
